import React, { FC, useState } from "react";
import { Control, useController } from "react-hook-form";
import { isValidPhoneNumber } from "react-phone-number-input";

import TelephoneBase from "@/components/ui/Form/Telephone/TelephoneBase";
import { TelephoneProps } from "@/types";

export interface InputControlledProps extends TelephoneProps {
  control: Control;
}
const TelephoneControlled: FC<InputControlledProps> = ({ control, ...rest }) => {
  const { phoneName, prefixName, onNumberChange, error } = rest;
  if (!phoneName || !prefixName) throw new Error("phoneName and prefixName are required in TelephoneControlled");
  const phoneField = useController({ control, name: phoneName });
  const prefixField = useController({ control, name: prefixName });

  // const numberChangeHandler = (e: any) => {
  //   console.log("telephone controlled ", e);
  // };

  // const prefixChangeHandler = (e: any) => {
  //   console.log("telephone controlled prefixChangeHandler ", e);
  // };

  return (
    <TelephoneBase
      phoneField={phoneField.field}
      phoneState={phoneField.fieldState}
      prefixField={prefixField.field}
      prefixState={prefixField.fieldState}
      // onPrefixChange={prefixChangeHandler}
      {...rest}
    />
  );
};
export default TelephoneControlled;
